import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

import { LoginComponent } from './login/login.component';

import { NgModule } from '@angular/core';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { AccountsComponent } from './modules/accounts/accounts.component';
import { CustomerComponent } from './modules/customer/customer.component';
import { ViewCustomerComponent } from './modules/customer/view-customer/view-customer.component';
import { AuditsComponent } from './modules/audits/audits.component';
import { MaintanenceComponent } from './modules/maintanence/maintanence.component';
import { HealthComponent } from './modules/health/health.component';
import { ViewHealthComponent } from './modules/health/view-health/view-health.component';
import { HomeComponent } from './home/home.component';
import { AccountHomeComponent } from './modules/accounts/account-home/account-home.component';
import { AccountListComponent } from './modules/accounts/account-list/account-list.component';
import { ListHealthComponent } from './modules/health/list-health/list-health.component';
import { AccountDetailsComponent } from './modules/accounts/view-account/account-details/account-details.component';
import { AccountFilterComponent } from './modules/accounts/account-filter/account-filter.component';
import { PaymentSettingsComponent } from './modules/accounts/view-account/payment-settings/payment-settings.component';
import { LicenseDetailsComponent } from './modules/accounts/view-account/license-details/license-details.component';
import { ViewAccountComponent } from './modules/accounts/view-account/view-account.component';
import { TransactionsComponent } from './modules/accounts/view-account/transactions/transactions.component';
import { InvoicesComponent } from './modules/accounts/view-account/invoices/invoices.component';
import { AccountResolverService } from './services/account-resolver.service';
import { ListCustomerComponent } from './modules/customer/list-customer/list-customer.component';
import { SupportLoginComponent } from './support/support-login/support-login.component';
import { SupportHomeComponent } from './support/support-home/support-home.component';
import { SupportDashboardComponent } from './support/support-dashboard/support-dashboard.component';
import { SupportAccountsComponent } from './support/support-accounts/support-accounts.component';
import { CouponsComponent } from './modules/coupons/coupons.component';
import { CouponListComponent } from './modules/coupons/coupon-list/coupon-list.component';
import { ViewCouponComponent } from './modules/coupons/coupon-list/view-coupon/view-coupon.component';
import { ReportsComponent } from './modules/reports/reports.component';
import { JaldeeReportComponent } from './modules/reports/jaldee-report/jaldee-report.component';
import { ViewJaldeeReportComponent } from './modules/reports/view-jaldee-report/view-jaldee-report.component';
import { JaldeeReportResolverService } from './services/jaldeeReport-resolver.service';
import { AccountPaymentListComponent } from './modules/accounts/account-payment-list/account-payment-list.component';
import { AwsSearchComponent } from './modules/accounts/aws-search/aws-search.component';
import { SearchDetailComponent } from './modules/accounts/search-detail/search-detail.component';
import { CorporatesComponent } from './modules/corporates/corporates.component';
import { ListCorporatesComponent } from './modules/corporates/list-corporates/list-corporates.component';
import { ViewCorporateComponent } from './modules/corporates/view-corporate/view-corporate.component';
import { UploadCorporateCSVComponent } from './modules/corporates/upload-corporate-csv/upload-corporate-csv.component';
import { ListBranchesComponent } from './modules/corporates/list-branches/list-branches.component';
import { UploadBranchLogoComponent } from './modules/corporates/upload-branch-logo/upload-branch-logo.component';
import { JaldeeVerifyLevelComponent } from './shared/components/jaldee-verify-level/jaldee-verify-level.component';
import { VerifyLogComponent } from './shared/components/jaldee-verify-level/verify-log/verify-log.component';
import { UpdateVerifyLevelComponent } from './shared/components/jaldee-verify-level/update-verify-level/update-verify-level.component';
import { VersionUpdateComponent } from './modules/version/version-update/version-update.component';
import { LoginHistoryComponent } from './modules/login-history/login-history.component';
import { JdnComponent } from './modules/corporates/jdn/jdn.component';
import { SalesComponent } from './modules/sales/sales.component';
import { JaldeeReimburseComponent } from './modules/reports/jaldee-reimburse/jaldee-reimburse.component';
import { UserComponent } from './modules/User/user.component';
import { UserListComponent } from './modules/User/user-list/user-list.component';
import { CreateUserComponent } from './modules/User/create-user/create-user.component';
import { ViewUserComponent } from './modules/User/view-user/view-user.component';
import { MarketingLoginComponent } from './marketing/marketing-login.component';
import { PaymentHistoryComponent } from './modules/accounts/view-account/payment-history/payment-history.component';
import { VirtualCallingComponent } from './modules/accounts/virtual-calling/virtual-calling.component';
import { ReimbursementReportComponent } from './modules/reimbursement-Report/reimbursement-report.component';
import { ReimbursementReportListComponent } from './modules/reimbursement-Report/reimbursement-report-list/reimbursement-report-list.component';
import { ViewReimbursementReportComponent } from './modules/reimbursement-Report/view-reimbursement-report/view-reimbursement-report.component';
import { UnverifiedAccountsComponent } from './modules/Unverified-Accounts/unverified-accounts.component';
import { UnverifiedAccountListComponent } from './modules/Unverified-Accounts/unverified-account-list/unverified-account-list.component';
import { AccountStatComponent } from './modules/bookingstat/account-stat.component';
import { BookingStatListComponent } from './modules/bookingstat/booking-stat-list/booking-stat-list.component';
import { BookingViewComponent } from './modules/bookingview/bookingview.component';
import { PaymentStatComponent } from './modules/paymentstat/payment-stat.component';
import { QuestionViewComponent } from './modules/accounts/view-account/question-view/question-view.component';
import { LabelComponent } from './modules/labels/label.component';
import { ListLabelComponent } from './modules/labels/list-label/list-label.component';
import { ViewLabelComponent } from './modules/labels/view-label/view-label.component';
import { JaldeeOffersComponent } from './modules/jaldee-offers/jaldee-offers.component';
import { PaymentStatListComponent } from './modules/paymentstat/payment-stat-list/payment-stat-list.component';
import { PaymentDetailsComponent } from './modules/accounts/view-account/payment-details/payment-details.component';
import { AccountUserComponent } from './modules/account-user/account-user.component';
import { AccountUserListComponent } from './modules/account-user/account-user-list/account-user-list.component';
import { ViewAccountUserComponent } from './modules/account-user/view-account-user/view-account-user.component';
import { ManagePwaComponent } from './modules/accounts/view-account/account-details/manage-pwa/manage-pwa.component';
import { CustomTemplatesComponent } from './modules/accounts/view-account/account-details/custom-templates/custom-templates.component';
import { TemplateViewComponent } from './modules/accounts/view-account/account-details/custom-templates/template-view/template-view.component';
import { UploadPaymentProfileComponent } from './shared/components/upload-payment-profile/upload-payment-profile.component';
import { AnalyticsComponent } from './modules/analytics/analytics.component';
import { AnalyticsFilterComponent } from './modules/analytics/analytics-filter/analytics-filter.component';
import { AnalyticsHomeComponent } from './modules/analytics/analytics-home/analytics-home.component';
import { AnalyticsListComponent } from './modules/analytics/analytics-list/analytics-list.component';
import { PrintStatementComponent } from './modules/jaldee-subscription/subscription-statements/statements/statement-list/print-statement/print-statement.component';
import { SectionViewComponent } from './modules/accounts/view-account/section-view/section-view.component';
import { AppsListComponent } from './modules/accounts/view-account/apps-list/apps-list.component';
import { DataMigrationListComponent } from './modules/accounts/view-account/data-migration-list/data-migration-list.component';
import { ConsentFormComponent } from './modules/accounts/view-account/consent-form/consent-form.component';
import { PrintProformaComponent } from './modules/jaldee-subscription/proforma-invoice/print-proforma/print-proforma.component';
// import { BookingStatListComponent } from './modules/bookingStat/booking-Stat-list/booking-Stat-list.component';
// import { BookingStatList1Component } from './modules/bookingStat/booking-Stat-list1/booking-Stat-list1.component';


const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomeComponent,
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        component: DashboardComponent
      },
      {
        path: 'analytics', component: AnalyticsComponent,


        children: [
          {
            path: '',
            redirectTo: 'filter',
            pathMatch: 'full'
          },
          {
            path: 'filter',
            component: AnalyticsFilterComponent,
            children: [
              {
                path: '',
                redirectTo: 'summary',
                pathMatch: 'full'
              },
              {
                path: 'summary',
                component: AnalyticsHomeComponent
              },
              {
                path: 'list',
                component: AnalyticsListComponent
              }
              // {
              //   path: 'searchdetail',
              //   component: SearchDetailComponent,
              // }
            ]
          },
        ]


      },
      {
        path: 'accounts',
        component: AccountsComponent,
        children: [
          {
            path: '',
            redirectTo: 'filter',
            pathMatch: 'full'
          },
          {
            path: 'filter',
            component: AccountFilterComponent,
            children: [
              {
                path: '',
                redirectTo: 'summary',
                pathMatch: 'full'
              },
              {
                path: 'summary',
                component: AccountHomeComponent
              },
              {
                path: 'list',
                component: AccountListComponent
              },
              {
                path: 'searchdetail',
                component: SearchDetailComponent,
              }
            ]
          },
          {
            path: 'view/:id',
            component: ViewAccountComponent, resolve: {
              accountDetails: AccountResolverService
            }, children: [
              { path: '', redirectTo: 'details', pathMatch: 'full' },
              { path: 'accountdetails', component: AccountDetailsComponent },
              {
                path: 'licensedetails',
                loadChildren: () => import('./modules/accounts/view-account/license-details/account-license.module').then(m => m.AccountLicenseModule)
              },
             // { path: 'paymentSettings', component: PaymentSettingsComponent },
              { path: 'paymentdetails', component: PaymentDetailsComponent },
              { path: 'invoice', component: InvoicesComponent },
              { path: 'print', component: PrintStatementComponent },
              { path: 'transactions', component: TransactionsComponent },
              { path: 'history', component: PaymentHistoryComponent },
              { path: 'details', component: AccountDetailsComponent },
              
              { path: 'section', component: SectionViewComponent },
              { path: 'apps', component: AppsListComponent },
              { path: 'migration', component: DataMigrationListComponent },
              { path: 'consentForm', component: ConsentFormComponent },
              { path: 'question', component: QuestionViewComponent },
              { path: 'pwa', component: ManagePwaComponent },
              { path: 'templates', component: CustomTemplatesComponent },
              { path: 'templates/:template', component: TemplateViewComponent }
            ]
          },
          {
            path: 'jaldeeVerification',
            component: JaldeeVerifyLevelComponent
            , children: [
              { path: '', redirectTo: 'update', pathMatch: 'full' },
              { path: 'log', component: VerifyLogComponent },
              { path: 'update', component: UpdateVerifyLevelComponent }

            ]
          },
          {
            path: 'paymentProfile',
            component: JaldeeVerifyLevelComponent
            , children: [
              { path: '', redirectTo: 'update', pathMatch: 'full' },
              { path: 'upload_payment', component: UploadPaymentProfileComponent }

            ]
          },
          
          {
            path: 'payment',
            component: AccountPaymentListComponent
          },
          {
            path: 'search',
            component: AwsSearchComponent,
            children: [
              {
                path: 'searchdetail',
                component: SearchDetailComponent,
              }
            ]
          }
        ]
      },
      {
        path: 'customers',
        component: CustomerComponent, children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          { path: 'list', component: ListCustomerComponent },
          { path: 'view/:id', component: ViewCustomerComponent }
        ]
      },
      {
        path: 'labels',
        component: LabelComponent, children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          { path: 'list', component: ListLabelComponent },
          { path: 'view/:id', component: ViewLabelComponent }
        ]
      },
      {
        path: 'accountUser',
        component: UserComponent, children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          { path: 'list', component: UserListComponent },
          { path: 'createuser', component: CreateUserComponent },
          { path: 'view/:id', component: ViewUserComponent },
          // {path: 'view/:id', component: ViewCustomerComponent}
        ]
      },
      {
        path: 'sales',
        loadChildren: () => import('./modules/sales/sales.module').then(m => m.SalesModule)
      },
      {
        path: 'subscription',
        children: [
          {
            path: '',
            redirectTo: 'statements',
            pathMatch: 'full'
          },
          { path: 'print', component: PrintStatementComponent },
            { path: 'printProforma', component: PrintProformaComponent },
          {
            path: 'baseDiscounts',
            // tslint:disable-next-line:max-line-length
            loadChildren: () => import('./modules/jaldee-subscription/subscription-base-discounts/subscription-base-discounts.module').then(m => m.SubscriptionBaseDiscountsModule)
          },
          {
            path: 'statements',
            // tslint:disable-next-line:max-line-length
            loadChildren: () => import('./modules/jaldee-subscription/subscription-statements/subscription-statements.module').then(m => m.SubscriptionStatementsModule)
          },
          {
            path: 'manualstatements',
            // tslint:disable-next-line:max-line-length
            loadChildren: () => import('./modules/jaldee-subscription/subscription-manualstatements/subscription-manualstatements.module').then(m => m.SubscriptionManualStatementsModule)
          },
          {
            path: 'proforma',
            // tslint:disable-next-line:max-line-length
            loadChildren: () => import('./modules/jaldee-subscription/proforma-invoice/proforma-invoice.module').then(m => m.ProformaInvoiceModule)
          },
          // tslint:disable-next-line:max-line-length
          { path: 'discounts', loadChildren: () => import('./modules/jaldee-subscription/subscription-discounts/subscription-discounts.module').then(m => m.SubscriptionDiscountsModule) }
        ]
      },
      {
        path: 'offers',
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          { path: 'list', component: JaldeeOffersComponent },
          {
            path: 'cash',
            // tslint:disable-next-line:max-line-length
            loadChildren: () => import('./modules/jaldee-offers/jaldee-cashs/jaldee-cash.module').then(m => m.JaldeeCashModule)
          },
          // tslint:disable-next-line:max-line-length
          { path: 'coupon', loadChildren: () => import('./modules/jaldee-offers/jaldee-coupon/jaldee-coupon.module').then(m => m.JaldeeCouponModule) }
        ]
      },
      {
        path: 'corporates',
        component: CorporatesComponent, children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          { path: 'list', component: ListCorporatesComponent },
          { path: 'view/:id', component: ViewCorporateComponent },
          { path: 'uploadcsv', component: UploadCorporateCSVComponent },
          { path: 'branches', component: ListBranchesComponent },
          { path: 'uploadlogo', component: UploadBranchLogoComponent },
          { path: 'jdn', component: JdnComponent },
          { path: 'licensedetails', loadChildren: () => import('./modules/corporates/corporate-license/corporate-license.module').then(m => m.CorporateLicenseModule) },
          {
            path: 'jaldeeVerification',
            component: JaldeeVerifyLevelComponent
            , children: [
              { path: '', redirectTo: 'update', pathMatch: 'full' },
              { path: 'log', component: VerifyLogComponent },
              { path: 'update', component: UpdateVerifyLevelComponent }

            ]
          }
        ]
      },
      {
        path: 'audits',
        component: AuditsComponent
      },
      {
        path: 'version',
        component: VersionUpdateComponent
      },
      {
        path: 'maintanence',
        component: MaintanenceComponent
      },
      {
        path: 'accountUsers',
        component: AccountUserComponent, children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          { path: 'list', component: AccountUserListComponent },
          { path: 'view/:id', component: ViewAccountUserComponent },
        ]
      },
      // {
      //   path: 'accountStat',
      //   component: BookingDetailsComponent, children: [
      //     {
      //       path: '',
      //       redirectTo: 'list',
      //       pathMatch: 'full'
      //     },
      //     { path: 'list', component: BookingDashboardComponent },
      //     { path: 'view/:id', component: ViewAccountUserComponent },
      //   ]
      // },
      {
        path: 'paymentStat',
        component: PaymentStatComponent, children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
        ]
      },
      { path: 'paymentStat/splist', component: PaymentStatListComponent },
      {
        path: 'accountStat',
        component: AccountStatComponent, children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
        ]
      },
      { path: 'accountStat/splist', component: BookingStatListComponent },
      {
        path: 'view/:id',
        component: ViewAccountComponent, resolve: {
          accountDetails: AccountResolverService
        }, children: [
          { path: '', redirectTo: 'details', pathMatch: 'full' },
          { path: 'details', component: AccountDetailsComponent }

        ]
      },
      { path: 'details', component: AccountDetailsComponent },
      {
        path: 'bookingView',
        component: BookingViewComponent, children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
        ]
      },
      {
        path: 'Reimbursement',
        component: ReimbursementReportComponent, children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          { path: 'list', component: ReimbursementReportListComponent },
          {
            path: 'view/:id',
            children: [
              {
                path: ':uId/:invoiceId/:s3UrlPath',
                component: ViewReimbursementReportComponent,
                resolve: {
                  reportDetails: JaldeeReportResolverService
                }
              }
            ]
          },
          //  { path: 'view/:id', component: ViewReimbursementReportComponent},
        ]
      },
      {
        path: 'Unverified',
        component: UnverifiedAccountsComponent, children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          { path: 'list', component: UnverifiedAccountListComponent },
        ]
      },
      {
        path: 'health',
        component: HealthComponent,
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            component: ListHealthComponent
          },
          {
            path: 'view/:id/:source',
            component: ViewHealthComponent
          }
        ]
      },
      {
        path: 'coupons',
        component: CouponsComponent,
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            component: CouponListComponent
          },
          {
            path: 'view/:id',
            component: ViewCouponComponent
          }
        ]
      },
      {
        path: 'reports',
        component: ReportsComponent,
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full',
          },
          {
            path: 'view/:id',
            component: JaldeeReportComponent,
          },
          // {
          //   path: 'view/:uId/:invoiceId',
          //   component: ViewJaldeeReportComponent,
          //    resolve: {
          //     reportDetails: JaldeeReportResolverService
          // }
          // },
          {
            path: 'view/:id',
            children: [
              {
                path: ':uId/:invoiceId/:s3UrlPath',
                component: ViewJaldeeReportComponent,
                resolve: {
                  reportDetails: JaldeeReportResolverService
                }
              }
            ]
          },
          {
            path: 'list',
            component: JaldeeReimburseComponent,
            //  children: [
            //   {
            //     path: '',
            //     component: JaldeeReportComponent
            //   }]
          }
        ]
      },
      {
        path: 'loginHistory',
        component: LoginHistoryComponent, children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
        ]
      },
     
      {
        path: 'view/:id',
        component: ViewAccountComponent, resolve: {
          accountDetails: AccountResolverService
        }, children: [
          { path: '', redirectTo: 'details', pathMatch: 'full' },
          { path: 'details', component: AccountDetailsComponent }

        ]
      },
      { path: 'customers/view/:id', component: ViewCustomerComponent },
      // { path: 'details', component: AccountDetailsComponent },
     
     
    
      // {
      //   path: 'accountUser',
      //    component: UserComponent
      // }
      // tslint:disable-next-line:max-line-length
    ]
  },
  { path: 'login', component: LoginComponent },
  { path: 'supportlogin', component: SupportLoginComponent },
  {
    path: '',
    component: SupportHomeComponent,
    children: [
      {
        path: '',
        redirectTo: 'home/dashboard',
        pathMatch: 'full'
      },
      {
        path: 'home/dashboard',
        component: SupportDashboardComponent
      },
      {
        path: 'accounts',
        component: SupportAccountsComponent,

      }
    ]
  },

  { path: 'login', component: LoginComponent },
  { path: 'marketlogin', component: MarketingLoginComponent },
  { path: 'logout', redirectTo: 'login', pathMatch: 'full' },
  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];
@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [RouterModule],
  providers: [AccountResolverService]

})
export class AppRouting { }
